import { videoCategories } from '@/mocks/videos';
import { Link } from 'react-router-dom';

interface CategoryTabsProps {
  activeCategory: string;
  onCategoryChange: (slug: string) => void;
}

export default function CategoryTabs({ activeCategory, onCategoryChange }: CategoryTabsProps) {
  return (
    <section id="video-categories" className="px-4 md:px-6 py-6 md:py-8 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
          {videoCategories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => onCategoryChange(cat.slug)}
              className={`flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 cursor-pointer whitespace-nowrap ${
                activeCategory === cat.slug
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-base`}></i>
              </div>
              {cat.name}
            </button>
          ))}
          <Link
            to={`/category/${activeCategory}`}
            className="flex items-center gap-1 px-4 py-2.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer ml-auto"
          >
            查看更多
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}